type InputField = {
  id: string;
  type: string;
  pattern: string;
  maxLength?: number;
};

export enum DeviceType {
  mobile = 'mobile',
  tablet = 'tablet',
  computer = 'computer',
  watch = 'watch',
}

// Source https://api.radera.tech/api/v2/retail/itemgroups
export const DEVICE_TYPE_GROUPS: {
  [device in keyof typeof DeviceType]: readonly number[];
} = {
  mobile: [1],
  tablet: [3],
  watch: [4],
  computer: [12, 54],
} as const;

export const EMAIL_DATA_FIELD_ID = 26;
export const SELF_SERVICE_URL_DATA_FIELD_ID = 4301;
export const SKU_DATA_FIELD_ID = 6130;
export const MODEL_PICTURE_URL_ID = 5150;

export const ERROR_CODES = {
  TRADEIN_ALREADY_CANCELED: 'B090001',
} as const;

export const CUSTOMER_STATUS = {
  CONFIRMED: 2,
  DECLINED: 3,
} as const;

export const INPUT_FIELDS: { [name: string]: InputField } = {
  firstName: { id: '71', type: 'text', pattern: '.+' },
  lastName: { id: '72', type: 'text', pattern: '.+' },
  address: { id: '79', type: 'text', pattern: '.+', maxLength: 35 },
  postalCode: { id: '80', type: 'text', pattern: '.+' },
  city: { id: '81', type: 'text', pattern: '.+' },
  email: { id: EMAIL_DATA_FIELD_ID.toString(), type: 'email', pattern: '.+' },
  iban: {
    id: '2040',
    type: 'text',
    pattern: '^(SE[0-9]{22}|(DK|FO|GL)[0-9]{16})$',
  },
};

export const FOXWAY_TRADE_IN_STATUS = {
  // Confirmed
  REGISTERED: 'Registered', // trade-in registered.
  SHIPMENT_CREATED: 'Shipment Created', // shipping label created
  EXPIRED: 'Expired', // consumer has not shipped device in time & Foxway does not keep the original price, but will re-calculate it if device received later.

  // Shipped
  SHIPPED: 'Shipped', // device shipped according to tracking number

  // Delivered
  DELIVERED: 'Delivered', // device received by Foxway according to tracking number
  RECEIVED: 'Received', // device received by Foxway, not yet processed
  PROCESSED_IN_FOXWAY: 'ProcessedInFoxway', // device received by Foxway, not yet processed
  BEING_PROCESSED: 'Being Processed', // ?
  PROCESSED_EXPIRED: 'Processed/Expired', // Device received later than should have. Can also go to discrepancy flow (onhold, confirmed, declined).

  // Discrepancy
  PROCESSED_ON_HOLD: 'Processed/OnHold', // device processed by Foxway, discrepancy, call-to-action email sent to consumer

  // Completed
  PROCESSED: 'Processed', // device processed by Foxway, no discrepancy
  PROCESSED_CONFIRMED: 'Processed/Confirmed', // consumer accepted new valuation after discrepancy

  // Canceled
  PROCESSED_DECLINED: 'Processed/Declined', // consumer did not accept new valuation, device should be sent back.
  RETURNED: 'Returned', // device returned to consumer
  CANCELED: 'Canceled', // trade-in canceled by Foxway

  // Unknown
  REPORTED: 'Reported', // reported by Foxway
  INVOICED: 'Invoiced', // invoiced by Foxway
  WITHHELD: 'Withheld', // ?
  GENERIC: 'Generic', // ?
  PACKED: 'Packed', // ?
  NOT_ELIGIBLE: 'NotEligible', //?
} as const;

export const FOXWAY_FLEX_PLAN_STATUS = {
  PENDING: 'PENDING',
  PENDINGPAID: 'PENDINGPAID',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  CLOSED: 'CLOSED',
  SIGNED: 'SIGNED',
  SHIPPED: 'SHIPPED',
  UPGRADED: 'UPGRADED',
  UPGRADEDANDRECEIVED: 'UPGRADEDANDRECEIVED',
  UPGRADEDANDRECEIVEDDAMAGED: 'UPGRADEDANDRECEIVEDDAMAGED',
  UPGRADEDANDRECEIVEDAPPROVED: 'UPGRADEDANDRECEIVEDAPPROVED',
  REMORSERETURN: 'REMORSERETURN',
  ONLYFORUPGRADE: 'ONLYFORUPGRADE',
  ONLYFORUPGRADEPAID: 'ONLYFORUPGRADEPAID',
  ONLYFORUPGRADESIGNED: 'ONLYFORUPGRADESIGNED',
  BILLINGREACTIVATED: 'BILLINGREACTIVATED',
  ARCHIVED: 'ARCHIVED',
  WRITEOFF: 'WRITEOFF',
} as const;
